module.exports = __webpack_public_path__ + "img/chambre8.daf19ff2.jpeg";